<template>
  <div
    style="position: absolute; top: 0px; left: 0px; width: 100vw; height: 100vh; overflow-x: hidden"
  >
    <svg
      id="visual"
      viewBox="0 0 960 540"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
    >
      <!-- first layer -->
      <path
        :d="wave_1.morph_1"
        :fill="wave_1.colour"
        transform="scale(1.1,1.0)"
      >
        <animate
          :dur="duration"
          id="w1m1"
          begin="0;w1m2.end"
          attributeName="d"
          :to="wave_1.morph_2"
        />
        <animate
          :dur="duration"
          id="w1m2"
          begin="w1m1.end"
          attributeName="d"
          :from="wave_1.morph_2"
          :to="wave_1.morph_1"
        />
      </path>

      <!-- second layer -->
      <path
        :d="wave_2.morph_1"
        :fill="wave_2.colour"
        transform="scale(1.1,1.0)"
      >
        <animate
          :dur="duration"
          id="w2m1"
          begin="0;w2m2.end"
          attributeName="d"
          :to="wave_2.morph_2"
        />
        <animate
          :dur="duration"
          id="w2m2"
          begin="w2m1.end"
          attributeName="d"
          :from="wave_2.morph_2"
          :to="wave_2.morph_1"
        />
      </path>

      <!-- third layer -->
      <path
        :d="wave_3.morph_1"
        :fill="wave_3.colour"
        transform="scale(1.1,1.0)"
      >
        <animate
          :dur="duration"
          id="w3m1"
          begin="0;w3m2.end"
          attributeName="d"
          :to="wave_3.morph_2"
        />
        <animate
          :dur="duration"
          id="w3m2"
          begin="w3m1.end"
          attributeName="d"
          :from="wave_3.morph_2"
          :to="wave_3.morph_1"
        />
      </path>

      <!-- fourth layer -->
      <path
        :d="wave_4.morph_1"
        :fill="wave_4.colour"
        transform="scale(1.1,1.0)"
      >
        <animate
          :dur="duration"
          id="w4m1"
          begin="0;w4m2.end"
          attributeName="d"
          :to="wave_4.morph_2"
        />
        <animate
          :dur="duration"
          id="w4m2"
          begin="w4m1.end"
          attributeName="d"
          :from="wave_4.morph_2"
          :to="wave_4.morph_1"
        />
      </path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'MorphWaveBackground',
  data: () => ({
    duration: '2s',
    wave_1: {
      colour: '#adc8d2',
      morph_1:
        'M0 352L18.8 346.2C37.7 340.3 75.3 328.7 112.8 325C150.3 321.3 187.7 325.7 225.2 337.8C262.7 350 300.3 370 337.8 377.8C375.3 385.7 412.7 381.3 450.2 376.8C487.7 372.3 525.3 367.7 562.8 368C600.3 368.3 637.7 373.7 675.2 370.8C712.7 368 750.3 357 787.8 357C825.3 357 862.7 368 881.3 373.5L900 379L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
      morph_2:
        'M0 331L18.8 335C37.7 339 75.3 347 112.8 359.2C150.3 371.3 187.7 387.7 225.2 383.7C262.7 379.7 300.3 355.3 337.8 344.8C375.3 334.3 412.7 337.7 450.2 348.3C487.7 359 525.3 377 562.8 383.5C600.3 390 637.7 385 675.2 372.7C712.7 360.3 750.3 340.7 787.8 331.7C825.3 322.7 862.7 324.3 881.3 325.2L900 326L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z;',
    },
    wave_2: {
      colour: '#cfd6d7',
      morph_1:
        'M0 414L18.8 413.3C37.7 412.7 75.3 411.3 112.8 411.3C150.3 411.3 187.7 412.7 225.2 406.7C262.7 400.7 300.3 387.3 337.8 388.8C375.3 390.3 412.7 406.7 450.2 408.5C487.7 410.3 525.3 397.7 562.8 394.5C600.3 391.3 637.7 397.7 675.2 407C712.7 416.3 750.3 428.7 787.8 426.2C825.3 423.7 862.7 406.3 881.3 397.7L900 389L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
      morph_2:
        'M0 367L18.8 374.5C37.7 382 75.3 397 112.8 402.7C150.3 408.3 187.7 404.7 225.2 400C262.7 395.3 300.3 389.7 337.8 392C375.3 394.3 412.7 404.7 450.2 407.5C487.7 410.3 525.3 405.7 562.8 397.3C600.3 389 637.7 377 675.2 373.7C712.7 370.3 750.3 375.7 787.8 383.2C825.3 390.7 862.7 400.3 881.3 405.2L900 410L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
    },
    wave_3: {
      colour: '#eee1dd',
      morph_1:
        'M0 433L18.8 431.5C37.7 430 75.3 427 112.8 432C150.3 437 187.7 450 225.2 450.5C262.7 451 300.3 439 337.8 437.5C375.3 436 412.7 445 450.2 452.2C487.7 459.3 525.3 464.7 562.8 463.3C600.3 462 637.7 454 675.2 453.2C712.7 452.3 750.3 458.7 787.8 463.8C825.3 469 862.7 473 881.3 475L900 477L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
      morph_2:
        'M0 424L18.8 432.3C37.7 440.7 75.3 457.3 112.8 456.5C150.3 455.7 187.7 437.3 225.2 431.8C262.7 426.3 300.3 433.7 337.8 433.3C375.3 433 412.7 425 450.2 424.7C487.7 424.3 525.3 431.7 562.8 439.3C600.3 447 637.7 455 675.2 459.7C712.7 464.3 750.3 465.7 787.8 462.2C825.3 458.7 862.7 450.3 881.3 446.2L900 442L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
    },
    wave_4: {
      colour: '#f5f7fa',
      morph_1:
        'M0 508L18.8 503.8C37.7 499.7 75.3 491.3 112.8 490.7C150.3 490 187.7 497 225.2 499.5C262.7 502 300.3 500 337.8 494C375.3 488 412.7 478 450.2 478.7C487.7 479.3 525.3 490.7 562.8 492C600.3 493.3 637.7 484.7 675.2 478C712.7 471.3 750.3 466.7 787.8 471.2C825.3 475.7 862.7 489.3 881.3 496.2L900 503L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
      morph_2:
        'M0 501L18.8 498.5C37.7 496 75.3 491 112.8 491.2C150.3 491.3 187.7 496.7 225.2 499.7C262.7 502.7 300.3 503.3 337.8 503C375.3 502.7 412.7 501.3 450.2 501.3C487.7 501.3 525.3 502.7 562.8 498.7C600.3 494.7 637.7 485.3 675.2 486.3C712.7 487.3 750.3 498.7 787.8 498.3C825.3 498 862.7 486 881.3 480L900 474L900 541L881.3 541C862.7 541 825.3 541 787.8 541C750.3 541 712.7 541 675.2 541C637.7 541 600.3 541 562.8 541C525.3 541 487.7 541 450.2 541C412.7 541 375.3 541 337.8 541C300.3 541 262.7 541 225.2 541C187.7 541 150.3 541 112.8 541C75.3 541 37.7 541 18.8 541L0 541Z',
    },
  }),
};
</script>

<style scoped>
svg {
  position: absolute;
  bottom: 0;
  left: 0;
  min-height: 500px;
}
</style>
